import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { Fragment as i } from "react";
import o from "styled-components";
import { ColorTokens as n } from "@vds-tokens/color";
import { Title as r, Micro as l, Feature as a, Body as p } from "@vds-core/typography";
import { TypographyTokens as c } from "@vds-tokens/typography";
import { withVDSManager as s } from "@vds-core/utilities";
import h from "./Tooltip.js";
var d = o.span.withConfig({
    displayName: "ChildWrapper",
    componentId: "VDS__sc-1pye5lv-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: ", ";\n  box-sizing: border-box;\n  margin: 0;\n  border: 0;\n  padding: 0;\n  display: inline-block;\n"])), function (_ref) {
    var e = _ref.$trailingElementHeight;
    return e;
  }),
  u = o.span.withConfig({
    displayName: "TooltipContent",
    componentId: "VDS__sc-1pye5lv-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-weight: 400;\n"]))),
  g = o.span.withConfig({
    displayName: "StyledSpan",
    componentId: "VDS__sc-1pye5lv-2"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-block;\n  outline: none;\n"]))),
  m = o.span.withConfig({
    displayName: "InlineWrapper",
    componentId: "VDS__sc-1pye5lv-3"
  })(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  vertical-align: middle;\n  font-size: ", ";\n"])), function (_ref2) {
    var e = _ref2.$tooltipSize;
    return "small" === e ? "1rem" : "1.25rem";
  }),
  y = o.span.withConfig({
    displayName: "InlineInnerWrapper",
    componentId: "VDS__sc-1pye5lv-4"
  })(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: inline-block;\n"])));
function f(e) {
  var t = "";
  return e.forEach(function (i, o) {
    o !== e.length - 1 && (t += "".concat(i, " "));
  }), t;
}
function v(e) {
  var t = e.props && e.props.children ? (o = e.props.children, Array.isArray(o) ? o && o.filter(function (e) {
    return "boolean" != typeof e;
  }).map(function (e) {
    return e.type === i ? e.props.children instanceof Array ? e.props.children[0] : e.props.children : e;
  }) : o) : e;
  var o;
  var n = t.length - 1,
    r = t[n],
    l = "string" != typeof t[n],
    a = "string" == typeof t,
    p = [];
  if (void 0 === t.length || t.length <= 1) return {
    childArray: [],
    textWithIcon: t
  };
  if (l || !a) return t.forEach(function (e, t) {
    t !== n && (p[t] = e);
  }), {
    childArray: p,
    textWithIcon: r
  };
  var c = t.split(" "),
    s = c[c.length - 1];
  return {
    childArray: f(c),
    textWithIcon: s
  };
}
function b(i) {
  var o = i.children,
    n = i.tooltipSize,
    r = i.tooltipTitle,
    l = i.tooltipContent,
    a = i.tooltipButtonText,
    p = i.tooltipCloseButtonText,
    s = i.tooltip,
    f = i.surface,
    b = i.containerId,
    z = i.ariaLabel,
    C = i.iconFillColor,
    I = i.renderAnchorElement,
    T = i.disabled,
    x = i.renderTooltipDialog,
    S = o ? v(o).childArray : [],
    w = o ? v(o).textWithIcon : "",
    A = function (e) {
      var t = e.typographyType,
        i = e.typographySize,
        o = e.viewport;
      if ("micro" === t) return c.lineheight.micro[16].value;
      if ("body" === t) switch (i) {
        case "medium":
          return c.lineheight.body[18].value;
        case "large":
          return c.lineheight.body[20].value;
        default:
          return c.lineheight.body[16].value;
      }
      if ("title" === t) switch (i) {
        case "small":
          return "mobile" === o ? c.lineheight.title[20].value : c.lineheight.title[24].value;
        case "large":
          return "mobile" === o ? c.lineheight.title[28].value : c.lineheight.title[36].value;
        case "XLarge":
          return "mobile" === o ? c.lineheight.title[36].value : c.lineheight.title[48].value;
        case "2XLarge":
          return "mobile" === o ? c.lineheight.title[40].value : c.lineheight.title[64].value;
        default:
          return "mobile" === o ? c.lineheight.title[24].value : c.lineheight.title[28].value;
      }
    }(i);
  return t(g, {
    children: [S, t(d, {
      $trailingElementHeight: A,
      children: [w, e(m, {
        $tooltipSize: s && s.size ? s.size : n,
        children: e(y, {
          children: e(h, Object.assign({}, s, {
            renderTooltipDialog: x,
            disabled: T,
            size: s && s.size ? s.size : n,
            title: s && s.title ? s.title : r,
            closeButtonText: s && s.closeButtonText ? s.closeButtonText : void 0 !== a ? a : p,
            surface: f,
            containerId: s && s.containerId ? s.containerId : b,
            ariaLabel: s && s.ariaLabel ? s.ariaLabel : z,
            iconFillColor: s && s.iconFillColor || C,
            renderAnchorElement: s && s.renderAnchorElement ? s.renderAnchorElement : I,
            children: e(u, {
              children: s && s.children ? s.children : l
            })
          }))
        })
      })]
    })]
  });
}
var z = function z(t) {
  var i = t.typographyPrimitive,
    o = t.viewport,
    c = t.typographySize,
    s = t.typographyType,
    h = t.bold,
    d = t.typographyColor,
    u = t.surface,
    g = t.id,
    m = {
      primitive: i,
      viewport: o,
      color: d || n.elements.primary["on".concat(u)].value,
      bold: h,
      id: g
    },
    y = b(t);
  return "title" === s ? e(r, Object.assign({}, m, {
    size: c,
    children: y
  })) : "micro" === s ? e(l, Object.assign({}, m, {
    children: y
  })) : e("feature" === s ? a : p, Object.assign({}, m, {
    size: c,
    children: y
  }));
};
z.defaultProps = {
  disabled: !1,
  typographyType: "body",
  viewport: "desktop",
  typographySize: "small",
  tooltipSize: "small",
  iconFillColor: "primary",
  renderTooltipDialog: !0,
  surface: "light",
  tooltipCloseButtonText: "Close"
};
var C = s(z);
export { C as default };